export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8134.1c27c963.jpg";